import type { Infer } from 'superstruct';
import { array, object, optional } from 'superstruct';

import { EditPermissionsDto } from '@adflow/shared/util-data';
import { ViewRoleDto } from '@adflow/shared/util-roles';
import {
	email,
	parsableBoolean,
	userString,
} from '@adflow/shared/util-superstruct';

export const AddUserFormDto = object({
	name: userString('validations:Required'),
	email: email(),
	superuser: optional(parsableBoolean()),
	permissions: EditPermissionsDto,
	roles: optional(array(ViewRoleDto)),
	sendWelcomeEmail: parsableBoolean(),
});

export type AddUserFormDto = Infer<typeof AddUserFormDto>;
